import type { MouseEventHandler } from 'react';
import { Inline, Stack, Text, textVariants } from '@etg/wings';
import { Counter } from '@eti/components';
import { css } from '@eti/styles';

const inlineStyles = css`
  justify-content: space-between;
`;
const subTitleStyles = css`
  color: #737373;
  margin-top: -16px;
  max-width: 75%;
`;

interface OptionProps {
  hasMinusDisabled: boolean;
  hasPlusDisabled: boolean;
  id: string;
  onPlusClick: MouseEventHandler<HTMLButtonElement>;
  onMinusClick: MouseEventHandler<HTMLButtonElement>;
  title: string;
  value: number;
  subTitle?: string;
}

const OptionLabel = ({
  hasMinusDisabled,
  hasPlusDisabled,
  id,
  onPlusClick,
  onMinusClick,
  title,
  value,
  subTitle,
}: OptionProps) => (
  <Stack>
    <Inline className={inlineStyles} noWrap>
      <Text as="p" variant={textVariants._16}>
        {title}
      </Text>
      <Counter
        hasMinusDisabled={hasMinusDisabled}
        hasPlusDisabled={hasPlusDisabled}
        id={id}
        onMinusClick={onMinusClick}
        onPlusClick={onPlusClick}
        value={value}
      />
    </Inline>
    <Text as="p" className={subTitleStyles} variant={textVariants._14}>
      {subTitle}
    </Text>
  </Stack>
);

export default OptionLabel;
